var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row align-items-center mt-3" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("p", [
              _c(
                "strong",
                [
                  _vm._v(
                    "\n\t\t\t\t\tAllgemeine Geschäftsbedingungen für die Nutzung von\n\t\t\t\t\t"
                  ),
                  _c("router-link", { attrs: { to: "/home" } }, [
                    _vm._v("www.dein-idealer-job.de"),
                  ]),
                  _vm._v(" in\n\t\t\t\t\tDeutschland\n\t\t\t  "),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Stand: 06.02.2022")]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v(
                  "\n              Die folgenden Geschäftsbedingungen regeln das unentgeltliche\n              Vertragsverhältnis zwischen\n              "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  "\n              (Vertragspartner ist die aquadrat – Dr Meyer, Krombholz, Heinze,\n              Leuchtenstern, Romer Gbr Pfaffenschlag 10, 96114 Hirschaid) und\n              seinen Kunden.\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("\n              1.1\n              "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  "\n              bietet seinen Kunden während der Vertragslaufzeit den Zugriff auf\n              eine Online-Datenbank, über die sie sich mit ihren Werten und\n              Eigenschaften Unternehmen vorstellen können. Dieser Service ist\n              ausschließlich über folgende Webseiten abrufbar:\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _c("ul", [
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v("www.dein-idealer-job.de"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v("www.dein-idealer-job.com"),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Der Service ist für Endkunden kostenlos")]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("1.2 Die von "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " zur Verfügung gestellte Online-Datenbank enthält sogenannte Profile, die von den angemeldeten Kunden mit eigenen Inhalten (auch als „Daten“ bezeichnet) versehen werden. Welche Daten in diesem Zusammenhang erhoben werden und wie diese Daten anderen Kunden gegenüber sichtbar sind, ergibt sich auch aus den gesonderten Datenschutzhinweisen."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("2.1 Der Zugang zur Nutzung von "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " setzt die Anmeldung voraus. Hierfür benötigt der Kunde eine E-Mail-Adresse und ein von ihm selbst gewähltes Passwort."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v(
                  "2.2 Mit der Anmeldung entsteht zunächst ein grundsätzlich kostenloses Vertragsverhältnis zwischen "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(" und dem angemeldeten Kunden."),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("2.3 Um "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " zu nutzen, ist es erforderlich, das Profil komplett auszufüllen. Dies beinhaltet auch Daten wie E-Mailadresse, Wohnort, Gehaltswunsch etc. Erst nach Vorliegen aller Angaben ist das Profil für Firmen sichtbar."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("3.1 "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " bietet im ersten Schritt eine kostenlose Registrierung. Im Anschluss daran kann der Kunde ein vollständiges Profil seiner beruflichen Werte und Ziele anhand eines Fragebogens erstellen. Zusätzlich können persönliche Daten hinterlegt werden. Wenn das Profil vollständig ausgefüllt ist, werden die Daten des Kunden mit den offenen Stellenanzeigen aller im System befindlichen Unternehmen verglichen. Die Unternehmen erhalten eine anonymisierte Auswertung welcher Kunde am besten zu ihnen passt. Die Unternehmen haben dann die Möglichkeit ihr Interesse an einem Gespräch mit den einzelnen Kunden anzumelden. "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " wird dieses Interesse im System weitergeben und der Kunde kann darauf eingehen oder auch nicht. Hier endet das Dienstleistungsverhältnis von "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v("."),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("3.2 "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " strebt an, seinen Service durchgehend 24 Stunden, sieben Tage die Woche einsatzfähig mit einer Verfügbarkeit von 99,5 % im Jahresmittel zur Verfügung zu stellen. Hiervon ausgenommen sind Ausfallzeiten durch Wartung und Software-Updates sowie Zeiten, in denen der Dienst aufgrund von technischen oder sonstigen Problemen, die nicht im Einflussbereich von "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " liegen (höhere Gewalt, Verschulden Dritter etc.), über das Internet nicht zu erreichen ist. Um "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " in vollem Umfang nutzen zu können, muss der Kunde jeweils die neuesten (Browser-) Technologien verwenden oder deren Verwendung auf seinem Computer oder Smartphone ermöglichen (z.B. Aktivierung von Java Skript, Cookies, Pop-ups). Bei Benutzung älterer oder nicht allgemein gebräuchlicher Technologien kann es sein, dass der Kunde die Leistungen von "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(" nur eingeschränkt nutzen kann."),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Der Kunde hat jederzeit das Recht, den Vertrag über die kostenlose Basis-Mitgliedschaft mit sofortiger Wirkung zu kündigen."
              ),
            ]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("5.1 "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " kann nicht für falsche Angaben in den Anmeldungen und/oder Ausfüllung der Daten der Kunden verantwortlich gemacht werden. Hieraus folgt, dass "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " keine Haftung für die Richtigkeit der Ergebnisse des Fragebogens sowie die Inhalte des auf dessen Grundlage erstellten Portraits des Kunden übernehmen kann."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("5.2 "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " schuldet lediglich die Bereitstellung der IT-Dienstleistungen zur automatischen Vermittlung von Kontakten, nicht den Erfolg. "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " stellt nur die technische Vorrichtung bereit, generell eine Kontaktaufnahme zwischen Kunde und verschiedenen Firmen zu ermöglichen."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("5.3 "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " übernimmt überdies keine Haftung für den eventuellen Missbrauch von Informationen. Es ist möglich, dass Kunden "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " trotz Verbot in unzulässiger oder gesetzwidriger Weise nutzen. Für eine solche unzulässige oder gesetzwidrige Nutzung ist jede Haftung von "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(" ausgeschlossen. "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " haftet auch nicht dafür, dass Angaben und Informationen, die die Kunden selbst Dritten zugänglich gemacht haben, von diesen missbraucht werden."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("5.4 "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " gewährleistet nicht den jederzeitigen ordnungsgemäßen Betrieb bzw. die ununterbrochene Nutzbarkeit bzw. Erreichbarkeit des Service. Insbesondere haftet "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " nicht für Störungen der Qualität des Zugangs zum Service aufgrund höherer Gewalt oder aufgrund von Ereignissen, die "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(" nicht zu vertreten hat. Ferner haftet "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  ' nicht für die unbefugte Kenntniserlangung Dritter von persönlichen Daten von Kunden (z.B. durch einen unbefugten Zugriff von "Hackern" auf die Datenbank).'
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "6.1 Der Kunde ist für den Inhalt seiner Anmeldung und damit für die Informationen, die er über sich bereitstellt, allein verantwortlich. Der Kunde versichert, dass die angegebenen Daten der Wahrheit entsprechen und ihn persönlich beschreiben. Vorsätzlich und/oder in betrügerischer Absicht gemachte Falschangaben oder das Vorspiegeln einer anderen oder erdachten Identität können auch zivilrechtliche Schritte nach sich ziehen."
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("6.2 Der Kunde verpflichtet sich, "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " schadlos von jeglicher Art von Klagen, Schäden, Verlusten oder Forderungen zu halten, die durch seine Anmeldung und/oder Teilnahme bei diesem Service entstehen könnten, sofern der Kunde schuldhaft gehandelt hat. Dies gilt insbesondere für Schäden wegen übler Nachrede, Beleidigung, Verletzung von Persönlichkeitsrechten, wegen des Ausfalls von Dienstleistungen für andere Kunden, einem Verstoß gegen diese Geschäftsbedingungen, wegen der Verletzung von Immaterialgütern oder sonstiger Rechte. Der Aufwendungsersatzanspruch ist der Höhe nach auf die notwendigen bzw. die zu einem bestimmten Zweck erforderlichen Aufwendungen beschränkt."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "6.3 Der Kunde ist verpflichtet, E-Mails und andere Nachrichten vertraulich zu behandeln und diese nicht ohne Zustimmung ihres Urhebers bzw. ohne wichtigen Grund Dritten zugänglich zu machen. Gleiches gilt für Namen, Telefon- und Faxnummern, Wohn-, E-Mail-Adressen und/oder URLs bzw. sonstige personenbezogene Daten mit dem Kunden interagierender Firmen."
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("6.4 Der Kunde erklärt sich bereit, "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " umgehend mitzuteilen, wenn er wegen des Zustandekommens eines Arbeitsverhältnisses oder aus sonstigen Gründen an Matches nicht mehr interessiert ist oder wenn er Firmen nicht mehr als Match zur Verfügung stehen will."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "6.5 Die Nichtbeachtung einer der oben genannten Verhaltensverpflichtungen kann zu folgenden Sanktionen führen: Aufforderung zur Stellungnahme im Falle des Verdachts von Vertrags- / Gesetzesverstößen, Sperrung der Nutzung bis zur Aufklärung von Sachverhalten (insbesondere bei mehreren Beschwerden von beteiligten Firmen), Verwarnung eines Kunden, Ein- /Beschränkung bei der Nutzung von Anwendungen im Job-Service, teilweises Löschen von Inhalten."
              ),
            ]),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(" ist ein Online-Dienst. Als solcher kommuniziert "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " mit seinen Kunden entweder über die Bildschirmmaske im eingeloggten Zustand oder per E-Mail. Telefon-, Fax- und Post-Kommunikation wird ermöglicht, sofern es sich um Fragestellungen des Vertragsschlusses, oder der verschlüsselten E-Mailkommunikation handelt. Für die Erbringung der Hauptleistungen (das Matching zwischen Job-Interessenten und Firmen) sowie den Vertragsschluss selbst ist die Telefon-, Fax- und Post-Kommunikation ausgeschlossen."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " ist im Verhältnis zum Kunden alleiniger Rechtsinhaber der Vervielfältigungs-, Verbreitungs-, Verarbeitungs- und sämtlicher Urheberrechte sowie des Rechts der unkörperlichen Übertragung und Wiedergabe auf "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " sowie der einzelnen in ihr enthaltenen Inhalte. Die Nutzung sämtlicher Programme und der darin enthaltenen Inhalte, Materialien sowie Marken- und Handelsnamen ist ausschließlich zu den in diesen Geschäftsbedingungen genannten Zwecken zulässig."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(9),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "9.1 Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss deutschen Kollisionsrechts. Ist der Kunde Verbraucher mit Wohnsitz in der Europäischen Union, kann ggf. auch das Recht desjenigen Landes, in dem er seinen Wohnsitz hat, zur Anwendung kommen, sofern es sich um zwingende Bestimmungen handelt."
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v(
                  "9.2 Die EU-Kommission bietet die Möglichkeit zur Online-Streitbeilegung auf einer von ihr betriebenen Online-Plattform. Diese Plattform ist über den externen Link "
                ),
                _c(
                  "a",
                  { attrs: { href: "http://ec.europa.eu/consumers/odr/" } },
                  [_vm._v("http://ec.europa.eu/consumers/odr/")]
                ),
                _vm._v(" zu erreichen. "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " nimmt nicht an Streitbeilegungsverfahren vor Verbraucherschlichtungsstellen teil. Eine Rechtspflicht besteht insofern nicht."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(10),
            _vm._v(" "),
            _vm._m(11),
            _vm._v(" "),
            _vm._m(12),
            _vm._v(" "),
            _vm._m(13),
            _vm._v(" "),
            _vm._m(14),
            _vm._v(" "),
            _vm._m(15),
            _vm._v(" "),
            _vm._m(16),
            _vm._v(" "),
            _vm._m(17),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Der Vertrag erlischt mit Absendung des Widerrufs. Sobald Ihr Schreiben eingegangen ist, werden wir Ihre Daten unwiderruflich aus dem System löschen."
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Kosten entstehen Ihnen dafür keine.")]),
            _vm._v(" "),
            _vm._m(18),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("11.1 "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " ist berechtigt, dritte Dienstleister und Erfüllungsgehilfen mit der Erbringung von Teilen oder des ganzen Leistungsspektrums zu beauftragen, sofern für den Kunden hierdurch keine Nachteile entstehen."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "11.2 Sollte eine Bestimmung des Vertrags oder der AGB unwirksam sein oder werden oder sollte der Vertrag unvollständig sein, so wird der Vertrag in seinem übrigen Inhalt davon nicht berührt. Ergänzend gelten die gesetzlichen Bestimmungen."
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("11.3 Die Vertragssprache ist deutsch.")]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v(
                  "11.4 Im Rahmen des Vertragsschlusses erfolgt keine automatische Speicherung des Vertragstextes durch "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  ". Der Kunde ist deshalb angehalten, den zum Zeitpunkt des Vertragsschlusses jeweils gültigen, auf der Webseite von "
                ),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
                _vm._v(
                  " zugänglichen Vertragstext (AGB) auf seiner Festplatte zu speichern oder auf andere Weise zu archivieren."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "11.5 Verantwortlich für den Inhalt des Service ist die aquadrat – Dr Meyer, Krombholz, Heinze, Leuchtenstern, Romer GbR, Pfaffenschlag 10, 96114 Hirschaid, diese vertreten durch Florian Leuchtenstern."
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [_vm._v(" ")]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("strong", [_vm._v("Allgemeine Geschäftsbedingungen")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v("\n\t\t\t\t\t1. Gegenstand des Vertrags\n\t\t\t\t"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("2 Zugang/Vertragsschluss")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("3. Leistungen")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("4.Kündigung")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("5. Haftung")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("6. Verantwortlichkeit und Pflichten des Kunden")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("7. Kommunikation")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("8 Urheberrechte")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Anwendbares Recht, Alternative Streitbeilegung")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("10. Widerrufsbelehrung")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "10.1 Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsschlusses."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v("Um Ihr Widerrufsrecht auszuüben, müssen Sie uns, der "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n\t\t\t\taquadrat – Dr Meyer, Krombholz, Heinze, Leuchtenstern, Romer GbR "
      ),
      _c("br"),
      _vm._v("\n\t\t\t\tPfaffenschlag 10 "),
      _c("br"),
      _vm._v("\n\t\t\t\t96114 Hirschaid "),
      _c("br"),
      _vm._v("\n\t\t\t\tTelefon: + 49 (0) 911 92 86 76 52 "),
      _c("br"),
      _vm._v("\n\t\t\t\tTelefax: + 49 (0) 911 92 86 76 53 "),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "mailto:florian@leuchtenstern.com?subject=Widerruf" },
        },
        [_vm._v("Florian@Leuchtenstern.com")]
      ),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können folgendes Musterformular für ihren Widerruf verwenden \n\t\t\t\t"
        ),
        _c(
          "a",
          { attrs: { href: "../public/assets/Widerruf.pdf", download: "" } },
          [_vm._v("(Link)")]
        ),
        _vm._v("."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("10.2 Folgen des Widerrufs")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("11. Sonstiges")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }